import { render, staticRenderFns } from "./salesmanWorkRecords.vue?vue&type=template&id=04b58cae"
import script from "./salesmanWorkRecords.vue?vue&type=script&lang=js"
export * from "./salesmanWorkRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports